export { childResourceForbiddenStore } from './lib/child-resource-forbidden.store'
export {
  type ForbiddenErrorAction,
  type ForbiddenErrorActionKind,
  type ForbiddenErrorStateInfo,
  type ForbiddenErrorVariant,
  GLOBAL_FORBIDDEN_ERROR_STATES,
  resolveForbiddenErrorState
} from './lib/forbidden-error-states'
